module.exports = __webpack_public_path__ + "img/sv44on.24857683.svg";